import type { OrganisationDto } from '@dhl/mdp-api'
import { convertToOrganisationDataDto, type Organisation } from '~/modules/organisations/model'
import { isCccBusinessUnit, isPplCzBusinessUnit } from '~/common/model/businessunits'

export const convertToOrganisationDto = (organisation: Organisation, isCCC = false): OrganisationDto => ({
  ...organisation,
  data: isCCC
    ? { address: undefined }
    : isPplCzBusinessUnit(organisation.businessUnitCode)
      ? { ...convertToOrganisationDataDto(organisation.data), chamberOfCommerce: undefined }
      : { ...convertToOrganisationDataDto(organisation.data), icoNumber: undefined },
  ccc: isCccBusinessUnit(organisation.businessUnitCode) ? organisation.ccc : undefined,
})
